<h2 mat-dialog-title>{{mediaType}} details</h2>
<div mat-dialog-content>
  @if (mediaType == 'Image') {
    <img src="{{url}}" class="image"/>
  }
  @if (mediaType == 'Video') {
    <video width="100%" controls>
      <source src="{{url}}" type="video/mp4">
      Your browser does not support the video tag.
    </video>
  }
</div>
<div mat-dialog-actions align="center">
  <button mat-button (click)="onNoClick()">Close</button>
</div>